import {Component} from '@angular/core';

@Component({
  selector: 'emc-scheduler',
  templateUrl: 'scheduler.html',
  styleUrls: ['scheduler.scss']
})
export class SchedulerComponent {
  deliveryTime: string;
  scheduleEnabled: boolean;

  constructor() {
    this.deliveryTime = new Date().toISOString();
    this.scheduleEnabled = false;
  }
}
